<template>
  <v-img
    min-height="100vh"
    class="pt-header"
    :src="`${publicPath+'images/imagenes/blog2.jpg'}`"
    gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)"
    style="position: relative;"
    :class="[$vuetify.breakpoint.lgAndUp ? 'px-container' : 'px-5']"
  >
    <v-row my-12>
      <v-col
        cols="12"
        sm="12"
        md="12"
        lg="12"
        :class="[$vuetify.breakpoint.smAndUp ? 'px-12 py-12' : '']"
      >
        <v-divider color="white" class="mb-6 mt-12"></v-divider>              
        <h1
          :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
          class="font-weight-bold text-uppercase mb-6 white--text"
        >Sistema Vizcaya</h1>
        <v-expansion-panels :focusable="focusable" multiple v-model="panel">
          <v-expansion-panel class="mb-4" v-for="expan in dataSystem.expandibles" :key="expan.id">
            <v-expansion-panel-header  class="headline my-3 font-weight-medium">{{expan.title}}</v-expansion-panel-header>
              <v-expansion-panel-content class="title font-weight-regular">
                <br>
                <div v-html="expan.content" ></div>
              </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <br>
        <v-divider color="white" class="mb-6 mt-12"></v-divider>              
        <h1
          :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
          class="font-weight-bold text-uppercase mb-6 white--text"
        >Nuestros valores</h1>        
        <v-row class="mx-0">
          <v-col
            cols="12"
            sm="6"
            md="6" 
            lg="4"
            v-for="icono in dataSystem.iconos" :key="icono.id"
          >
            <v-card height="100%" style="border-radius: 0.8rem;">
              <v-card-title class="d-flex justify-center align-center ">
                <v-img
                  max-height="60"
                  contain 
                  v-bind:src="renderImage(icono.image)"
                  
                ></v-img>
              </v-card-title>
              <v-card-text class="text-center pt-3">
                <h3>{{ icono.title }}</h3>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> 
        <br>
        <v-divider color="white" class="mb-6 mt-12"></v-divider>              
        <h1
          :class="[$vuetify.breakpoint.mdAndUp ? 'display-2' : 'display-1']"
          class="font-weight-bold text-uppercase mb-6 white--text"
        >Carta del rector</h1>
        <v-card class="mb-5">   
          <v-card-title class="pt-8">
            <v-layout column justify-center align-center>
              <v-avatar size="200" color="black">
                <v-img src="https://www.uva.edu.mx/imagenes/rector_2020.jpg"></v-img>
              </v-avatar>
              <h1 class="headline text-center pt-5">
                Lic. Jorge Richardi Rochín
                <br />
                <small class="font-italic">Carta del rector</small>
              </h1>
            </v-layout>
          </v-card-title>
          <v-divider class="mx-12"></v-divider>              
          <v-card-text>
            <v-row class="mx-0 px-10" justify="center" align="center">
              <v-col cols="12" sm="12" md="10">
                <p class="body-1" style="text-align: justify;">
                  Nuestro país merece contar con niveles de educación acordes a
                  la demanda que la dinámica actual nos requiere. Estamos
                  compitiendo en entornos que día a día se van mostrando más
                  exigentes, motivo por el cual nuestra institución va
                  creciendo, fortaleciendo su nivel académico y su oferta
                  educativa, apostando a cubrir esas expectativas, con el apoyo
                  decidido de su planta de colaboradores, administrativos,
                  operativos y docentes, comprometidos, a través del esfuerzo
                  compartido, al logro de este gran reto, ser los forjadores del
                  profesionista distinguido de las regiones donde nos
                  encontramos.
                </p>
                <p class="body-1" style="text-align: justify;">
                  Somos reconocidos por nuestro espíritu de expansión, tanto en
                  centros educativos como a nivel territorial, lo cual nos ha
                  permitido cruzar fronteras a nivel nacional, y ser reconocidos
                  por esa experiencia que hemos ganado, a pesar de nuestra
                  juventud.
                </p>
                <p class="body-1" style="text-align: justify;">
                  Nuestra historia no ha sido fácil, con desvelos, pero con
                  muchas satisfacciones, que nos han brindado la suficiente
                  motivación para que nuestras expectativas a futuro inmediato y
                  mediato sean mas significativas.
                </p>
                <p class="body-1" style="text-align: justify;">
                  Poseemos el gran valor de creer en nosotros mismos, creer en
                  nuestra gente, creer en las comunidades donde ya estamos
                  educando mexicanos, y caminamos con paso firme hacia
                  horizontes que nos permitan el logro de mayores
                  satisfacciones.
                </p>
                <p class="body-1" style="text-align: justify;">
                  Sentimos un gran compromiso con las nuevas generaciones, y por
                  ello, estamos preparándonos para poder afrontarlo cada día con
                  mayor éxito, y nuestro éxito se traduce en cristalizar los
                  sueños de cada uno de los jóvenes que pasan por nuestras aulas
                  y sus familias, que confían en nuestro proyecto. ¡Vamos por
                  buen camino! Queremos que nos acompañes, y vivamos juntos la
                  fantástica experiencia de ser GENTE VIZCAYA.
                </p>
              </v-col>
            </v-row>
            <v-row class="mx-0">
              <v-col cols="12" sm="12" md="10">
                <h3 class="text-right">
                  Lic. Jorge Richardi Rochín
                  <br />
                  <small>Rector</small>
                </h3>
              </v-col>
            </v-row>
          </v-card-text>          
        </v-card>
      </v-col>
    </v-row>
  </v-img>
</template>
<style lang="scss" scoped>
.bg-Flex {
  background-size: cover !important;
}
.px-container {
  padding-left: 20%;
  padding-right: 20%;
}
.bg-flex-mobile {
  background-size: cover;
  height: 400px;
  margin-bottom: 1rem;
}
.pt-header {
  padding-top: 120px;
}
</style>
<script>
import axios from "axios";

export default {
      mounted() {
    var self = this
    axios({
      method: "post",
      data: {from: "Universidad"}, 
      url: "https://www.admin-uva.tidingo.com/api/data-system",
      config: {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json"
        },withCredentials: true, credentials: "same-origin"
      }
    }).then(function(response) {
      self.dataSystem=response.data;
      for (var i = 0; i < self.dataSystem.expandibles; i++) {
        self.panel.push(i)
      }
    }).catch(function(error) {});
  },
  computed: {
    image() {
      return this.publicPath + "image/imagenes/pop-up-informes.jpg";
    }
  },
  methods: {
    renderImage(value) {
      if (value != null) {
        if (value.indexOf("https") < 0) {
          return "https://www.admin-uva.tidingo.com/" + value;
        } else {
          return value;
        }
      } else {
        return "";
      }
    },
  },
  data: () => ({
      panel: [],
      focusable: true,
      publicPath: process.env.BASE_URL,
      dataSystem: {
        iconos: [],
        expandibles: [],
      },
      theClass: "<h1 class=‘font-italic my-10’>",
      theClassFinal: "</h1>",
  })

};
</script> 